import './index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import classnames from 'classnames';
import { useLoadingState } from '@hh.ru/magritte-common-use-loading-state';
import { Skeleton } from '@hh.ru/magritte-ui-skeleton';
import { s as styles } from './checkable-card-DJrOyTI9.js';

const CheckableCardSkeleton = forwardRef(({ Component: CheckableCard, 
// skeleton props
width, height, inline, additionalClass, loading, ...cardProps }, ref) => {
    const isLoading = useLoadingState() || loading;
    if (isLoading) {
        return (jsx("div", { className: classnames(styles.cardSkeleton, { [styles.cardHugContent]: !cardProps.flexible }), children: jsx(Skeleton, { width: !cardProps.flexible ? width : `100%`, height: !cardProps.flexible ? height : `100%`, borderRadius: cardProps.borderRadius, borderTopLeftRadius: cardProps.borderTopLeftRadius, borderTopRightRadius: cardProps.borderTopRightRadius, borderBottomLeftRadius: cardProps.borderBottomLeftRadius, borderBottomRightRadius: cardProps.borderBottomRightRadius, loading: loading }) }));
    }
    return jsx(CheckableCard, { ref: ref, ...cardProps });
});
CheckableCardSkeleton.displayName = 'CheckableCardSkeleton';

export { CheckableCardSkeleton };
//# sourceMappingURL=Skeleton.js.map
